import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
  chargeTemplates: any[];
}

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: "",
  chargeTemplates: []
};

export const contractCreateReducer =
  (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_CONTRACT_CREATE_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case Constants.GLOBAL_CONTRACT_CREATE_SUCCESS:
      return {
        ...state,
        isFetching: false
      };

    case Constants.GLOBAL_CONTRACT_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_CONTACT_PERSON_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage,
      };


    case Constants.PAGE_CONTACT_COMPANY_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage,
      };  

    case Constants.COACH_ERRORS_CLEAR:
      return {
        ...initialState
      };
      
    case Constants.PAGE_CONTRACT_CREATE_PUT_CHARGE_TEMPLATES_TO_MEMORY:
    return {
      ...state,
      chargeTemplates: [...action.payload?.chargeTemplates]
    };

    case Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_SUCCESS:
      return {
        ...state,
        chargeTemplates: state.chargeTemplates.some(chargeTemplate => chargeTemplate.id === action.payload?.chargeTemplate.id) ?
        [
          action.payload?.chargeTemplate,
          ...state.chargeTemplates.filter(chargeTemplate => chargeTemplate.id !== action.payload?.chargeTemplate.id)
        ] : [action.payload?.chargeTemplate, ...state.chargeTemplates]
      };

    case Constants.GLOBAL_CHARGE_TEMPLATE_DELETE_SUCCESS:
      return {
        ...state,
        chargeTemplates: [
          ...state.chargeTemplates.filter(chargeTemplate => chargeTemplate.id !== action.payload?.chargeTemplate.id)
        ]
      };

    case Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_FAILURE:
    case Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_FAILURE:
    case Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };


    case Constants.GLOBAL_CONTRACT_CREATE_ERRORS_CLEAR:
      return {
        ...state,
        fields: []
      };

    case Constants.GLOBAL_CHARGE_TYPE_CREATE_FAILURE:
      return {
        ...state,
       // isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_CLEAR:
    case Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_CLEAR:
    case Constants.GLOBAL_CONTRACT_CREATE_CLEAR:
    case Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR:
    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
